import { IMAGES_BASE_URL } from "./constants/baseURL";

export const HERO_IMAGE_BASE_URL = `${IMAGES_BASE_URL}/hero`;

const buildHeroImageUrls = (imagePath, width, isSourceSet = true) => (isSourceSet
  ? `${HERO_IMAGE_BASE_URL}/${imagePath}${width}px.jpg, ${HERO_IMAGE_BASE_URL}/${imagePath}${width}px_2x.jpg 2x`
  : `${HERO_IMAGE_BASE_URL}/${imagePath}${width}px.jpg`);

export default buildHeroImageUrls;
